module.exports = __webpack_public_path__ + "static/media/push-pin-fill.d5c95fe9.svg";